import React from "react";
import "./PST_IT_Solutions.css";

const PST_IT_Solutions = () => {
  const features = [
    {
      icon: "/assets/images/home/PST_IT_Solutions/logo-1.png",
      title: "Industry-Aligned Curriculum",
      desc:
        "Master high-demand technologies like Hadoop, DevOps, SQL, and Linux all curated to meet real-time industry expectations.",
    },
    {
      icon: "/assets/images/home/PST_IT_Solutions/logo-2.png",
      title: "Led by Industry Practitioners",
      desc:
        "Learn from seasoned data engineering experts who bring practical insights and real-world experience to every session.",
    },
    {
      icon: "/assets/images/home/PST_IT_Solutions/logo-3.png",
      title: "End-to-End Career Enablement",
      desc:
        "From personalized resume refinement to mock interviews and job prep we’re invested in your professional transformation.",
    },
  ];

  return (
    <section className="PST_IT_Solutions">
      <div className="container">
        <div className="PST_IT_Solutions_header">
          <h5 className="title">
            PST IT SOLUTIONS <span>Everywhere</span>
          </h5>
        </div>

        <div className="solution_content_holder">
          <div className="row">
            <div className="col-lg-7 col-md-7 order-lg-1 order-md-1 order-sm-2 order-2">
              <div className="solution_left_div">
                <div className="solution_title">
                  <h5 className="upskill"> UPSKILL</h5>
                  <h5 className="work">WHILE YOU WORK.</h5>
                  <h5 className="work">
                    <span className="upskill">GROW</span> WHILE YOU LEARN.
                  </h5>
                </div>

                <p className="solution_text">
                  At PST, we go beyond just teaching we shape careers! With
                  expert mentorship, hands-on learning, and guaranteed placement
                  support, we ensure you gain the skills and confidence to
                  thrive in the tech industry.
                </p>

                {features.map((item, index) => (
                  <div className="feature_card" key={index}>
                    <div className="feature_icon_holder">
                      <img
                        src={item.icon}
                        alt={item.title}
                        className="feature_icon"
                      />
                    </div>
                    <div className="feature_content">
                      <h4 className="feature_title">{item.title}</h4>
                      <p className="feature_desc">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-5 col-md-5 order-lg-2 order-sm-1 order-1">
              <div className="solution_right_div">
                <img
                  src="/assets/images/home/PST_IT_Solutions/group.png"
                  alt="group-img"
                  className="group_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PST_IT_Solutions;
